import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import { formReservationConfirmFields } from '../../constants/forms/formReservationConfirm';

export default createValidation([
  {
    name: formReservationConfirmFields.PRICE,
    validators: (field) => validatorRequired()(field),
  },
]);
